var _a;
import HomePage from '../home/Home';
import { Routes } from '../../routes/constants';
import { RequerimentoPesquisa } from '../Requerimento/Pesquisa/RequerimentoPesquisa';
import { RequerimentoCadastroRoot } from '../Requerimento/Cadastro/RequerimentoCadastroRoot';
import { RequerimentoTaxa } from '../Requerimento/Taxa/RequerimentoTaxa';
import RequerimentoVisualizacao from "../Requerimento/View/RequerimentoVisualizacao";
import { NotificacaoLista } from '../Notificacao/View/NotificacaoLista';
export var AppRoutes = (_a = {
        "/": HomePage
    },
    _a["".concat(Routes.REQUERIMENTO_LISTAR.path)] = RequerimentoPesquisa,
    _a["".concat(Routes.REQUERIMENTO_CADASTRO.path)] = RequerimentoCadastroRoot,
    _a["".concat(Routes.REQUERIMENTO_VISUALIZAR.path, "/:id")] = RequerimentoVisualizacao,
    _a["".concat(Routes.REQUERIMENTO_EDITAR.path, "/:id")] = RequerimentoCadastroRoot,
    _a["".concat(Routes.REQUERIMENTO_EMITIR_TAXAS.path, "/:id")] = RequerimentoTaxa,
    _a["".concat(Routes.NOTIFICACOES_LISTAR.path)] = NotificacaoLista,
    _a);
